export default "/images/framework/AssetBg.54481cdf.svg?54481cdf";